import { ExpensableBudgetFragment } from 'generated/resources/graphql'

import DropdownSearchBar from 'modules/core/components/DropdownSearchBar'
import i18n from 'modules/core/lib/i18n'

import { BudgetOption } from 'modules/finance/hooks/useBudgets'

interface Props {
  selectedBudgetId?: string
  expensableBudget?: ExpensableBudgetFragment | null
  budgetOptions: BudgetOption[]
  error?: string
  mandatory?: boolean
  readonly?: boolean
  loading?: boolean
  onSelect: (budgetId: string | null) => void
}

const BudgetField = ({
  selectedBudgetId,
  expensableBudget,
  budgetOptions,
  error,
  mandatory = false,
  readonly,
  loading,
  onSelect,
}: Props) => {
  const selectedBudgetOption = budgetOptions.find(
    ({ value: budgetId }) => selectedBudgetId === budgetId
  )

  return (
    <DropdownSearchBar
      name={selectedBudgetOption?.label || expensableBudget?.name || ''}
      label={i18n.t('budgets.forms.external_resource.budget_field.label')}
      ariaLabel={'budget-popover'}
      data={budgetOptions}
      error={error}
      selectLabel={i18n.t('budgets.forms.external_resource.budget_field.options.empty')}
      placeholder={i18n.t('budgets.forms.external_resource.budget_field.options.empty')}
      searchLabel={i18n.t('common.search')}
      sortLabel={i18n.t('common.name')}
      labelNotFound={i18n.t('budgets.forms.external_resource.budget_field.search.not_found')}
      disabled={readonly}
      loading={loading}
      autofocus={false}
      mandatory={mandatory}
      onSelectEmpty={!mandatory ? () => onSelect(null) : null}
      onSelect={(item) => {
        onSelect(String(item.value))
      }}
    />
  )
}

export default BudgetField
